import { getFileSizeFormat } from 'app/utils/files';
import { Button } from 'ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

type UploadedSelectedFileProps = {
  file: File;
  hasImage?: boolean;
  onDelete: () => void;
};

function UploadedSelectedFile({ file, hasImage = false, onDelete }: UploadedSelectedFileProps): JSX.Element {
  const { t } = useTranslation(['common']);
  const fileName = file.name;
  const size = getFileSizeFormat(file.size);

  function onClick(event: React.MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();
    onDelete();
  }

  return (
    <div className="uploaded-selected-file mb-2">
      <span className="uploaded-selected-file__title">{t('common:File uploaded')}:</span>
      <div className="uploaded-selected-file__box">
        <div className="uploaded-selected-file__info">
          {hasImage && file.type && file.type.startsWith('image/') && (
            <img className="uploaded-selected-file__img mr-3" src={URL.createObjectURL(file)} alt={fileName} />
          )}

          <span className="uploaded-selected-file__filename">{fileName}</span>
          <span className="uploaded-selected-file__size">{size}</span>
        </div>

        <div>
          <Button
            className="uploaded-selected-file__delete"
            variant="plain"
            isIconOnly
            leftIcon="trash"
            ariaLabel={t('common:Delete')}
            onClick={onClick}
          />
        </div>
      </div>
    </div>
  );
}

export default UploadedSelectedFile;
